import { useCallback } from 'react'
import { HistoryEvents } from '../utils'
import { canUseDom } from '../../isSsr'

export const useRouter = () => {
  const push = useCallback((url: URL) => {
    if (canUseDom && url.href !== window.location.href) {
      window.history.pushState(null, '', url)
      window.dispatchEvent(new Event(HistoryEvents.PushState))
    }
  }, [])

  const replace = useCallback((url: URL) => {
    if (canUseDom && url.href !== window.location.href) {
      window.history.replaceState(null, '', url)
      window.dispatchEvent(new Event(HistoryEvents.ReplaceState))
    }
  }, [])

  return {
    push,
    replace
  }
}
